import { render } from "./PDFPedidoFinal.vue?vue&type=template&id=8d8eb0e8&scoped=true"
import script from "./PDFPedidoFinal.vue?vue&type=script&lang=js"
export * from "./PDFPedidoFinal.vue?vue&type=script&lang=js"

import "./PDFPedidoFinal.vue?vue&type=style&index=0&id=8d8eb0e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d8eb0e8"]])

export default __exports__